import { render, staticRenderFns } from "./PersonUnderAgeOfConsent.vue?vue&type=template&id=18074bcc&"
import script from "./PersonUnderAgeOfConsent.vue?vue&type=script&lang=js&"
export * from "./PersonUnderAgeOfConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports